export default __webpack_public_path__ + "static/assets/e91530fe8f85b7fdc983b48ab3b9885d.svg";